<template>
  <Dialog
    v-model:visible="showModal"
    class="w-3/5 bg-white shadow rounded-xl"
    :modal="true"
  >
    <template #header>
      <div class="w-full text-gray-900 font-semibold">{{videoDataDetailed.title}}</div>
    </template>
    <div v-if="false" class="flex flex-wrap justify-center">
      <div
        class=" bg-white rounded-xl flex items-center w-2/3 p-2 shadow-sm border border-gray-200"
      >
        <i class="pi pi-search"></i>
        <input
          type="search"
          class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
        />
      </div>
      <button
        class="text-white px-4 whitespace-no-wrap rounded-xl transition duration-300 bg-blue-900 ml-4"
      >
        搜尋
      </button>
    </div>
    <div
      class="align-middle inline-block min-w-full shadow overflow-hidden bg-white shadow-dashboard px-8 pt-3 rounded-bl-lg rounded-br-lg"
    >
      <YouTube
        :src="videoDataDetailed.src"
        width="100%"
        height="480"
        @ready="onReady"
        ref="youtube" />
    </div>
    <template #footer> </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import InputText from 'primevue/inputtext'
import { FilterMatchMode, FilterOperator } from "primevue/api"
import Column from "primevue/column";
import axios from 'axios'
import Qs from 'qs'

export default {
  name: "PayRecordDialog",
  components: {
    Dialog,
    InputText,
    Column
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    videoData:{
      type:Object,
    },
    lang: {
      type: Object
    },
  },
  data() {
    return {

    };
  },
  watch: {
    'videoData'(v) {
      console.log('videoData:'+v)
    }
  },
  methods: {
    onReady() {
      console.log('youtube');
      this.$refs.youtube.playVideo()
    },
    // detailData(id, type) {
    //   console.log('id:'+id);
    //   console.log('type:'+type);

    //   if(id != '' && id != 'undefined' && type != '' && type != 'undefined'){
    //      axios
    //       .post('https://ci.local/_autoturn_local_inside/api/payment_details.php', Qs.stringify({
    //         s_code: this.$route.params.id,
    //         no: id,
    //         form: type
    //       }))
    //       .then((response) => {
    //         if(response.data.status == 'success'){
    //           this.details = response.data.return_data

    //           console.log('this.details');
    //           console.log(this.details);

    //           this.showDetail = true
    //         }
    //       });
    //   }
    // }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function(value) {
        this.$emit("update:show", value);
      }
    },
    videoDataDetailed: {
      get: function () {
        return this.videoData
      },
      set: function (value) {
        this.$emit('update:videoData', value)
      }
    }
  },
  mounted() {}
};
</script>

<style lang="scss" scoped>
::v-deep() {
  .p-datatable {
    tr button {
      opacity: 0;
    }

    tr {
      &:hover {
        button {
          opacity: 1;
        }
      }
    }
  }

  .p-datatable .p-datatable-thead > tr > th {
    background: transparent !important;
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr > td {
    border-bottom-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(107, 114, 128, var(--tw-border-opacity));
  }

  .p-datatable .p-datatable-tbody > tr:hover {
    --tw-bg-opacity: 1;
    background-color: rgba(249, 250, 251, var(--tw-bg-opacity));
  }
}
</style>
